var name = "Scarlet 200_2B3Pv1";
var uuid = "f0e1c99c-c476-4cc9-8378-d28a470aa143";
var pos = [
	0,
	0,
	0
];
var rot = [
	0,
	0,
	0
];
var size = [
	7.775,
	3.045,
	11.275
];
var anchor = [
	0.5,
	0,
	0.8226164069873949
];
var color = "#0072ce";
var alpha = 1;
var rg = true;
var type = "Apartment";
var children = [
	{
		name: "balcony",
		uuid: "9ad89ea2-4be7-4c7c-91b8-c1490c55d72a",
		pos: [
			-4.1875,
			0.145,
			-9.275
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			4.0375,
			0.16,
			1.5
		],
		anchor: [
			0,
			0,
			0
		],
		color: "#cccccc",
		alpha: 1,
		rg: true,
		type: "Balcony",
		children: [
			{
				name: "floor",
				uuid: "0da782a3-630b-4ef1-95f2-ef5e6ead19ca",
				pos: [
					2.0187,
					0.08,
					0.75
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					4.0375,
					0.16,
					1.5
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "BFA|01|",
				type: "Floor"
			}
		]
	},
	{
		name: "M4(2) Bathroom",
		uuid: "7af7d92b-f0f1-41c9-9824-16c3aae59bef",
		pos: [
			2.75,
			0.305,
			-1.2375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			2,
			2.4384,
			2.2
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#fe4365",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Bathroom"
		}
	},
	{
		name: "Utility",
		uuid: "f5265782-5984-4f48-b460-4e76778263af",
		pos: [
			2.15,
			0.305,
			-3.2325
		],
		rot: [
			0,
			180,
			0
		],
		size: [
			0.8,
			2.4384,
			1.6
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#c44d58",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Utility"
		}
	},
	{
		name: "Kitchen / Living / Dining",
		uuid: "229e2216-e458-416a-8caf-656bd6b4b235",
		pos: [
			-1.95,
			0.305,
			-3.95
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.6,
			2.4384,
			6.775
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#00a0b0",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "KitchenLivingDining",
			polygon: [
				[
					-0.15,
					0.305,
					-7.3375
				],
				[
					-3.75,
					0.305,
					-7.3375
				],
				[
					-3.75,
					0.305,
					-0.5625
				],
				[
					-1.645,
					0.305,
					-0.5625
				],
				[
					-1.645,
					0.305,
					-1.0375
				],
				[
					-1.645,
					0.305,
					-2.485
				],
				[
					-0.15,
					0.305,
					-2.485
				],
				[
					-0.15,
					0.305,
					-7.3375
				]
			]
		}
	},
	{
		name: "Bedroom Single",
		uuid: "f92f6258-19a6-47ee-a657-0db19c74586e",
		pos: [
			-1.95,
			0.305,
			0.4362
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.6,
			2.4384,
			2.8525
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#69d2e7",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "BedroomSingle",
			polygon: [
				[
					-3.75,
					0.305,
					-0.4675
				],
				[
					-3.75,
					0.305,
					1.8625
				],
				[
					-0.15,
					0.305,
					1.8625
				],
				[
					-0.15,
					0.305,
					-0.0688
				],
				[
					-0.15,
					0.305,
					-0.99
				],
				[
					-1.55,
					0.305,
					-0.99
				],
				[
					-1.55,
					0.305,
					-0.4675
				],
				[
					-3.75,
					0.305,
					-0.4675
				]
			]
		}
	},
	{
		name: "Bedroom Double",
		uuid: "6c318b81-8e0c-4ec0-a763-d0364dd02c20",
		pos: [
			1.95,
			0.305,
			-5.7325
		],
		rot: [
			0,
			180,
			0
		],
		size: [
			3.6,
			2.4384,
			3.21
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#a7dbd8",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "BedroomDouble"
		}
	},
	{
		name: "Storage",
		uuid: "7a9a1d67-975d-43ce-9c6c-1bdc66fa4f0f",
		pos: [
			3.1975,
			0.305,
			-3.2325
		],
		rot: [
			0,
			90,
			0
		],
		size: [
			1.6,
			2.4384,
			1.105
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#556270",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Storage"
		}
	},
	{
		name: "Hallway",
		uuid: "6c25cd56-d152-412c-920e-baf475e57733",
		pos: [
			0.0525,
			0.305,
			-2.085
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.205,
			2.4384,
			3.895
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#4ecdc4",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Hallway",
			polygon: [
				[
					0.15,
					0.305,
					-2.2375
				],
				[
					0.15,
					0.305,
					-4.0325
				],
				[
					1.655,
					0.305,
					-4.0325
				],
				[
					1.655,
					0.305,
					-2.385
				],
				[
					1.655,
					0.305,
					-0.1375
				],
				[
					0.15,
					0.305,
					-0.1375
				],
				[
					0.15,
					0.305,
					-1.2375
				],
				[
					-0.15,
					0.305,
					-1.2375
				],
				[
					-0.15,
					0.305,
					-1.085
				],
				[
					-1.55,
					0.305,
					-1.085
				],
				[
					-1.55,
					0.305,
					-2.39
				],
				[
					-0.15,
					0.305,
					-2.39
				],
				[
					-0.15,
					0.305,
					-2.2375
				],
				[
					0.15,
					0.305,
					-2.2375
				]
			]
		}
	},
	{
		name: "module",
		uuid: "7af3e9e1-da04-43c0-8dc9-9d0756074c0a",
		pos: [
			1.95,
			1.5225,
			-3.7375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.875,
			3.045,
			7.475
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#0072ce",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "1a0ada19-a842-4e3b-91a8-db0c21ce480f",
				pos: [
					0,
					0.0725,
					-3.6687
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.6,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "window",
						uuid: "501849c9-b2fe-4c4b-af45-f136d3338f6f",
						pos: [
							0,
							0.1425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.76,
							1.305,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#4b5e82",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "WNF|12|",
						type: "Window"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "6d2d0a9e-aa18-4d2c-bbff-a9c598074632",
				pos: [
					-1.8687,
					0.0725,
					-0.0687
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					7.3375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "2828dd99-3866-4cdc-8458-1c23ced19ddd",
						pos: [
							2.0687,
							-0.285,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.165,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "cce6a793-9085-4ec1-a6d1-a3c1ecde33a8",
				pos: [
					-0.0687,
					0.0725,
					3.6687
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.7375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "fd832a54-c1f4-4217-968c-0ff52d7957bf",
						pos: [
							1.0263,
							-0.2275,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.01,
							2.09,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|01|UK-DIS0001",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: true
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "3ac36a06-e549-4546-90b7-7bce5c0519db",
				pos: [
					1.8687,
					0.0725,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.475,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "dc2d5760-bc25-49ef-a222-a02a90034a88",
				pos: [
					0,
					0.07,
					-0.3425
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.6,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "3760a831-f65f-4e75-af35-882861584391",
						pos: [
							-1.2,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					},
					{
						name: "door",
						uuid: "2131a816-f4a0-475c-b9e6-87f925df74cb",
						pos: [
							1.25,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "76401715-b34b-4ebd-9b71-388f9d0072f8",
				pos: [
					0.6475,
					0.07,
					0.505
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					1.6,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "127886d2-1fcf-4336-9e26-800030711cae",
				pos: [
					0.8,
					0.07,
					1.3525
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					2,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "3258174e-7b5e-4f01-b4b7-0b1da26442b5",
				pos: [
					-0.2475,
					0.07,
					1.6525
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					3.895,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "5e8effbf-fd68-475a-9b19-75c113079986",
						pos: [
							-0.3475,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					},
					{
						name: "door",
						uuid: "892bd3b1-777a-4d40-b276-0a3568588d62",
						pos: [
							1.1275,
							-0.2425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.21,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DID|02|UK-DID0001",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "1c19a6a2-2984-4971-87b8-54c2ece2f691",
				pos: [
					0,
					-1.26,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.2,
					0.065,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "SCR|01|",
				type: "Floor"
			},
			{
				name: "beam",
				uuid: "546604d2-4080-4f2f-b8fb-81659267f410",
				pos: [
					0,
					-1.4075,
					-3.675
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "2cf2faaa-ffba-4444-a56f-5f89a12a9a20",
				pos: [
					0,
					-1.4075,
					3.675
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "79641db4-9680-49d3-b5c3-d89ae7d4ca6d",
				pos: [
					0,
					-1.372,
					-3.3013
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "ace341c8-ccfa-4d44-9bcc-8fa18403ef2f",
				pos: [
					0,
					-1.372,
					-3.5487
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "67e644d2-7138-47a7-ae5b-c809f158281c",
				pos: [
					0,
					-1.372,
					3.5487
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "b322a720-252f-420b-8ddf-9485fe0c0239",
				pos: [
					0,
					-1.372,
					3.3012
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "e619aa48-7c1a-4cf0-9712-3a626548a45f",
				pos: [
					0,
					-1.3595,
					0.805
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "2b484018-c9b3-4a6c-baed-80c1b0f1576f",
				pos: [
					0,
					-1.3595,
					0.745
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "08f1fc78-4a73-4330-9571-e6aa06f77409",
				pos: [
					0,
					-1.3595,
					2.105
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "bc863620-4be7-4c94-9e6d-986e0d696635",
				pos: [
					0,
					-1.3595,
					2.045
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "f9f61a1a-659a-4902-9404-30394a77ede4",
				pos: [
					-1.875,
					-1.4075,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.26,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "51282368-f819-4045-aa76-5652578fca09",
				pos: [
					1.875,
					-1.4075,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.26,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "33796ec8-46a6-4994-8b41-fcd992773b00",
				pos: [
					-1.875,
					0.0812,
					3.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "22be9b73-949a-47e5-821d-8fd55808610d",
				pos: [
					-1.875,
					0.0812,
					-3.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "a43a7256-a903-4fe2-be5d-5525c2486072",
				pos: [
					1.875,
					0.0812,
					3.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "eb1d5ddf-7572-42b1-9a24-b046cde57143",
				pos: [
					1.875,
					0.0812,
					-3.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "ce0a242a-a6aa-4b66-8671-e399e17fac1b",
				pos: [
					0,
					-1.372,
					-0.6012
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "7c3194a4-e82d-49b4-91bd-c1e32070c6ec",
				pos: [
					0,
					-1.372,
					-0.8488
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "866337e8-581e-4369-9bd2-1ec6921955e4",
				pos: [
					-1.875,
					0.0812,
					-0.725
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "be13ad86-ffe4-420e-86b4-c442de5c5b6b",
				pos: [
					1.875,
					0.0812,
					-0.725
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "b6a0344f-ba16-43cb-9c0d-0fb34b7001cd",
				pos: [
					0,
					-1.3595,
					-2.035
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "96c472bc-f9b6-4db2-a4a5-43622399b427",
				pos: [
					0,
					-1.3595,
					-2.095
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "floor",
				uuid: "4ce257d3-2500-48c0-b136-9e560d5d3bfa",
				pos: [
					0,
					-1.2225,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.2,
					0.01,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FFN|01|",
				type: "Floor"
			},
			{
				name: "ceiling",
				uuid: "b3c28b7d-2962-42f6-b1e4-8d8a64cac4c4",
				pos: [
					0,
					1.445,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.2,
					0.155,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	},
	{
		name: "module",
		uuid: "d6ca9ebe-c77b-42f3-b1c2-00871dd984d4",
		pos: [
			-1.95,
			1.5225,
			-2.7375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.875,
			3.045,
			9.475
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#0072ce",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "126db30b-4074-4587-80b3-a1214d63a76e",
				pos: [
					0,
					0.0725,
					-4.6687
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.6,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "af6c123f-7da7-430c-beef-e71172cf948b",
						pos: [
							0,
							-0.2525,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.75,
							2.085,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DCD|01|UK-DCD0003",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "9a212b5c-41de-4502-8923-ef0830f1666d",
				pos: [
					-1.8687,
					0.0725,
					-0.0687
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					9.3375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "window",
						uuid: "62a2265d-00a3-4308-89de-6ddb03ce78ea",
						pos: [
							3.4937,
							0.1425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.15,
							1.305,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#4b5e82",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "WNF|14|",
						type: "Window"
					},
					{
						name: "window",
						uuid: "7a3788e0-7a16-4ef1-9d89-d7b25fbb6aa8",
						pos: [
							-0.7063,
							0.1425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							0.85,
							1.305,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#4b5e82",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "WNF|13|",
						type: "Window"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "546773b3-0dd9-4161-a004-ce6ce1199de4",
				pos: [
					-0.0688,
					0.0725,
					4.6687
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.7375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "dbb28518-15f5-4838-8c06-c309968ffeaf",
				pos: [
					1.8687,
					0.0725,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					9.475,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "4eb48dde-9cd2-46fb-b869-e7cd3a083501",
						pos: [
							-1,
							-0.285,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.165,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "81e70c0a-475e-4d4f-bd2f-b49b96bca43e",
				pos: [
					0,
					-1.26,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					9.2,
					0.065,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "SCR|01|",
				type: "Floor"
			},
			{
				name: "wall",
				uuid: "95707f2d-7c16-48c3-ab01-8fae9a6fc8bd",
				pos: [
					0.3525,
					0.07,
					1.3087
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					1.9225,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "c072fe7d-dd7c-40b2-a229-7914c24082ad",
				pos: [
					-0.7475,
					0.07,
					2.2225
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.105,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "cf84984a-aa08-4deb-9fdf-762baf9aa35b",
				pos: [
					1.0525,
					0.07,
					0.3
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					1.495,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "6652b9be-c382-454d-b573-00e75aa6fddc",
						pos: [
							-0.0475,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "5118e780-4f8b-499b-8d31-0a6d6ae4ca4f",
				pos: [
					1.1,
					0.07,
					1.7
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					1.4,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "9e314f20-629f-4158-bca3-391014059f79",
						pos: [
							0,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "beam",
				uuid: "c649459d-c229-49a7-8b93-7b3d56cb5b64",
				pos: [
					0,
					-1.4075,
					-4.675
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "5def51fe-1d64-4f25-8cf4-5fd16fa1e1f9",
				pos: [
					0,
					-1.4075,
					4.675
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "17642b7a-ca0b-4a4c-b686-7d728dfd5054",
				pos: [
					0,
					-1.372,
					4.5487
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "960dbd28-d6fe-4104-8d89-69bc3dfe501a",
				pos: [
					0,
					-1.372,
					4.3012
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "612d4ebf-72b7-4c2d-9dd5-339da6a683d6",
				pos: [
					0,
					-1.3595,
					-0.255
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "8374a937-c33f-46ba-be52-ccc591126acd",
				pos: [
					0,
					-1.3595,
					-0.315
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "14fbe011-b7b2-489a-87a3-8fdd10e83d5d",
				pos: [
					0,
					-1.3595,
					1.045
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "66707938-40b9-4e65-b0a9-e48cb9f19b74",
				pos: [
					0,
					-1.3595,
					0.985
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "8426fbf7-7f49-4579-b1ea-206c7d4f517f",
				pos: [
					-1.875,
					-1.4075,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					9.26,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "a2d1d030-878c-4c4a-bc39-1e8ed2d03a32",
				pos: [
					1.875,
					-1.4075,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					9.26,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "753ab57e-6f2a-4750-82b3-c3ea8b3a67a7",
				pos: [
					-1.875,
					0.0812,
					4.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "bba56e11-e5dc-4652-88fb-1be9dba2377a",
				pos: [
					1.875,
					0.0812,
					4.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "91e7708a-70a1-4954-bbf2-62cfa898b56b",
				pos: [
					0,
					-1.372,
					-4.3013
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "337c778b-3b9d-4afb-81bd-6ea112e4031b",
				pos: [
					0,
					-1.372,
					-4.5487
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "7e8d30b2-ef12-48ad-9236-07a32239f1f8",
				pos: [
					-1.875,
					0.0812,
					-4.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "cc6c852d-0bce-4a08-a657-416388a7bd55",
				pos: [
					1.875,
					0.0812,
					-4.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "b791aad3-fe6f-47d8-8033-cdb58659a7f6",
				pos: [
					0,
					-1.372,
					-1.6012
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "6b1e1c20-3788-4432-89f5-af3f8827ee96",
				pos: [
					0,
					-1.372,
					-1.8488
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "cf65189f-51b6-4bc7-8c26-ac1b8fa7fee4",
				pos: [
					-1.875,
					0.0812,
					-1.725
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "9018ce75-bc37-4c42-a2bd-49ec3a966559",
				pos: [
					0,
					-1.372,
					2.5487
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "fa445a94-b913-455d-b579-a71da8b1a696",
				pos: [
					0,
					-1.372,
					2.3012
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "9b8cf693-cd4d-443c-a1c9-24492e2cad76",
				pos: [
					-1.875,
					0.0812,
					2.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "dedc2b52-427f-446a-aca6-da50e8123de0",
				pos: [
					1.875,
					0.0812,
					2.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "e3c6e6b8-194a-4893-a030-9598a4a1a5e2",
				pos: [
					0,
					-1.3595,
					3.485
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "d92c7c40-5f4b-42ea-a464-180091341f21",
				pos: [
					0,
					-1.3595,
					3.425
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "9bf804dd-16a8-40d6-b0ae-7fb18b8af8c2",
				pos: [
					0,
					-1.3595,
					-3.195
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "221340b5-b881-4f6a-b544-56cfc968485e",
				pos: [
					0,
					-1.3595,
					-3.135
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "19639f6e-dc11-4092-a5f7-4b3fb0fe7bda",
				pos: [
					1.875,
					0.0812,
					-1.725
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "floor",
				uuid: "5b8cafd8-1d4b-49b9-9e1f-c6ebb02f3c35",
				pos: [
					0,
					-1.2225,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					9.2,
					0.01,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FFN|01|",
				type: "Floor"
			},
			{
				name: "ceiling",
				uuid: "ddec0a4c-cfad-4833-819a-198e581b4959",
				pos: [
					0,
					1.445,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					9.2,
					0.155,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	}
];
var data = {
	level: -1,
	levelId: "",
	occupants: 3,
	bedrooms: 2,
	habitableRooms: 3,
	nia: 61.2,
	muscleID: "",
	category: "2B3P",
	closeCorridor: true,
	closeDirection: [
		-1,
		0,
		0
	],
	closeLength: 3.875
};
var UK01_2B3P_V1 = {
	name: name,
	uuid: uuid,
	pos: pos,
	rot: rot,
	size: size,
	anchor: anchor,
	color: color,
	alpha: alpha,
	rg: rg,
	type: type,
	children: children,
	data: data
};

export { alpha, anchor, children, color, data, UK01_2B3P_V1 as default, name, pos, rg, rot, size, type, uuid };
//# sourceMappingURL=Scarlet-200-2B3Pv1.json.js.map
